define('app/controllers/pagaments',['angular', 'app/services/shared'], function(angular) {
  var module = angular.module('app.pagaments', ['app.shared']);

  module.controller('PagamentNewController', [
    '$scope',
    '$http',
    '$route',
    '$compile',
    '$location',
    '$filter',
    'sharedProperties',
    'consumer',
    'state',
    'info',
    'elem',
    'elems',
    'extrainfo',
    function($scope, $http, $route, $compile, $location, $filter, sharedProperties, consumer, state, info, elem, elems, extrainfo) {
      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elem = {FincaId:elem.Id,Finca:elem};
      $scope.elems = elem;
      $scope.extrainfo = extrainfo;

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;
        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.elem = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason);
        }, function (update) {
          console.log('Got notification', update);
        })
      });


    }
  ]);

  return module;
});

